import { Icon } from "@/components/icon";
import type { NavProps } from "@/components/nav";

export const frontendNavData: NavProps["data"] = [
	{
		name: "Pages",
		items: [
			{
				title: "Users",
				path: "/users",
				icon: <Icon icon="local:ic-user" size="24" />,
			},
			{
				title: "User Scrapes",
				path: "/user-scrapes",
				icon: <Icon icon="solar:document-text-bold-duotone" size="24" />,
			},
			{
				title: "Feedbacks",
				path: "/feedbacks",
				icon: <Icon icon="local:ic-chat" size="24" />,
			},
			{
				title: "Emails",
				path: "/emails",
				icon: <Icon icon="local:ic-mail" size="24" />,
			},
			{
				title: "Unlockables",
				path: "/unlockables",
				icon: <Icon icon="solar:key-bold-duotone" size="24" />,
			},
			{
				title: "Unlockable Discounts",
				path: "/unlockable-discounts",
				icon: <Icon icon="solar:tag-price-bold-duotone" size="24" />,
			},
			{
				title: "Status Timings",
				path: "/advertisement-request-status-timings",
				icon: <Icon icon="solar:clock-circle-bold-duotone" size="24" />,
			},
			{
				title: "Agentic",
				path: "/agentic",
				icon: <Icon icon="solar:hierarchy-bold-duotone" size="24" />,
			},
			{
				title: "Economics",
				path: "/economics",
				icon: <Icon icon="solar:chart-line-duotone" size="24" />,
			},
			{
				title: "Token Packages",
				path: "/token-packages",
				icon: <Icon icon="solar:wallet-money-bold-duotone" size="24" />,
			},
			{
				title: "Ad Request Queue",
				path: "/advertisement-request-queues",
				icon: <Icon icon="mdi:chart-timeline-variant" size="24" />,
			},
			{
				title: "External Reports",
				path: "/external-reports",
				icon: <Icon icon="solar:document-bold" size="24" />,
			},
		],
	},
];
